/*
----------------------------
Module - accordion-nav
----------------------------
*/

import $ from 'jquery';
/*global fmg*/

(function () {
    'use strict';

    fmg.accordionNav = function() {

        function setupKeyboardControls() {

            $accordion_nav.keydown(function(evt) {
                
                // Escape key is pressed
                if (evt.which == 27) {
                    
                    // Get focused element when keydown happened
                    var $focused_element = $(evt.target);

                    var $closest_active_button = $focused_element.closest(".accordion-nav__menu-item").find("[aria-expanded='true']");

                    if ($closest_active_button.length) {

                        // Refocus on related button if focused element is within an expanded sub menu
                        $closest_active_button.trigger('focus');

                        // Close the expanded submenu
                        toggleSubmenu($closest_active_button, true);

                    }
                                        
                }

            });
            
        }

        function toggleSubmenu($button, is_active) {

            var $parent_menu = $button.parent();
            var $sub_menu = $parent_menu.find(".accordion-nav__submenu");
            var $sub_menu_items = $parent_menu.find(".accordion-nav__submenu li");

            if (is_active === "false") {

                $parent_menu.toggleClass(menu_expanded_classname);

                // Expand submenu
                $sub_menu.slideDown("fast");

                $sub_menu_items.removeClass("fadeOutAnimated")
                               .addClass("fadeInAnimated");

                $button.attr("aria-expanded", "true");

            } else {
                $sub_menu_items.removeClass("fadeInAnimated")
                               .addClass("fadeOutAnimated");

                // Close submenu
                $sub_menu.slideUp("fast", function() {
                    $parent_menu.toggleClass(menu_expanded_classname);
                });

                $button.attr("aria-expanded", "false");

            }

        }

        function setupButtons() {

            $buttons.click(function(evt) {

                var $this_button = $(evt.target);

                var is_active = $this_button.attr("aria-expanded");
                
                toggleSubmenu($this_button, is_active)

            });

        }

        function init() {

            $accordion_nav = $(".accordion-nav");

            if ($accordion_nav.length) {

                $buttons = $accordion_nav.find(".accordion-nav__button");
 
                setupButtons();
                setupKeyboardControls();

            }

        }

        var $accordion_nav;
        var $buttons;
        var menu_expanded_classname = "accordion-nav__menu-item--expanded";

        return {
            init: init
        }


    }();
        
    document.addEventListener("DOMContentLoaded", function () {
        fmg.accordionNav.init();
    });

}());


